import React from "react";

const BS5_Images = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Images Component</h2>
      <p>This is the BS5_Images component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Images;
